import DPDropDown from "framework/components/DPDropDown";
import React, { useState } from "react"
import { CardText, Col, Row, Alert } from "reactstrap"

import DPTextBox from "../../../framework/components/DPTextBox"


const VendorBank = ({
    show,
    disabled,
    AlertColor,
    AlertMsg,
    ErrorMsg,
    fieldManager,
    bankDetails,
    handleBankChanges
}) => {

    return (
        <React.Fragment>
            <div>
                <Row>
                    <Col sm="12">
                        <CardText className="mb-0">
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Row>
                                <Col sm={12} md={6} className="mb-4-sm">

                                    <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_ACCOUNT')}>
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Account Number"
                                            textType="text"
                                            maxLength="50"
                                            onChange={handleBankChanges}
                                            value={bankDetails.accountCode}
                                            name={"accountCode"}
                                            disabled={disabled}
                                        />
                                    </div>
                                    <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_BANKNAME')}>
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Bank Name"
                                            textType="text"
                                            maxLength="50"
                                            onChange={handleBankChanges}
                                            value={bankDetails.bankName}
                                            name={"bankName"}
                                            disabled={disabled}
                                        />
                                    </div>
                                    <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_BANKCODE')}>
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Bank Code"
                                            textType="text"
                                            maxLength="50"
                                            onChange={handleBankChanges}
                                            value={bankDetails.bankCode}
                                            name={"bankCode"}
                                            disabled={disabled}
                                        />
                                    </div>
                                    <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_BRANCHNAME')}>
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Branch Name"
                                            textType="text"
                                            maxLength="50"
                                            onChange={handleBankChanges}
                                            value={bankDetails.branchName}
                                            name={"branchName"}
                                            disabled={disabled}
                                        />
                                    </div>
                                    <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_BRANCHCODE')}>
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Branch Code"
                                            textType="text"
                                            maxLength="50"
                                            onChange={handleBankChanges}
                                            value={bankDetails.branchCode}
                                            name={"branchCode"}
                                            disabled={disabled}
                                        />
                                    </div>
                                    <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_BRANCHCODE')}>
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Payee Name / Cheque Name"
                                            textType="text"
                                            maxLength="50"
                                            onChange={handleBankChanges}
                                            value={bankDetails.payeeName}
                                            name={"payeeName"}
                                            disabled={disabled}
                                        />
                                    </div>
                                    <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_BRANCHCODE')}>
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="With Holding Tax (WHT) %"
                                            textType="text"
                                            maxLength="50"
                                            textAlign={"right"}
                                            onChange={handleBankChanges}
                                            value={bankDetails.whtTax}
                                            onBlur={handleBankChanges}
                                            name={"whtTax"}
                                            disabled={disabled}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </CardText>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}


export default VendorBank
